import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { Link } from 'react-router';
import { rem } from 'polished';
import { DsiCheckBox as CheckBox } from '../../../..';
import { FlexRow, FlexRowCenter } from '../../../Defaults/Flexbox/Flexbox';
import { __, __r } from 'react-i18n';

interface Props {
  id?: string;
  onClick?: (e: any) => void;
  selected: boolean;
  label?: string;
  theme: any;
  name?: string;
  rounded?: boolean;
}

function AcceptTermsCheckbox({
  id,
  name = '',
  onClick,
  selected,
  theme,
  rounded,
}: Props) {
  const handleClick = e => {
    if (onClick) {
      onClick({
        ...e,
        target: {
          value: !selected,
          name,
        },
      });
    }
  };

  return (
    <Wrapper>
      <CheckBox
        /* tslint:disable-next-line:jsx-no-lambda */
        onClick={e => handleClick(e)}
        selected={selected}
      />
      <Label onClick={handleClick}>
        {__('Oboznámil som sa so')}{' '}
        <LabelLink
          to={__r(
            'routes:vseobecne-obchodne-podmienky',
            'vseobecne-obchodne-podmienky',
          )}
          target="_blank"
        >
          {__('Všeobecnými obchodnými podmienkami')}
        </LabelLink>{' '}
        {__('a podmienkami o')}{' '}
        <LabelLink
          to={__r('routes:ochrana-osobnych-udajov', '/ochrana-osobnych-udajov')}
          target="_blank"
        >
          {__('ochrane osobných údajov')}
        </LabelLink>
        {', '}{' '}
        {__(
          'prečítal som ich a porozumel ich obsahu a v celom rozsahu s nimi súhlasím',
        )}
        {'.'}
      </Label>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRow)`
  align-items: center;
  margin-right: ${rem(30)};
  margin-bottom: ${rem(32)};
`;

const Label = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: ${rem(16)};
  font-weight: 400;
  cursor: pointer;
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const LabelLink = styled(Link)`
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${rem(16)};
  font-weight: 400;
  text-decoration: underline;
  ${({ theme }) => theme.mediab.m810`
    font-size: ${rem(14)};
  `}
`;

const WithThemeCheckBox: any = withTheme(AcceptTermsCheckbox);
export { WithThemeCheckBox as AcceptTermsCheckbox };
